import * as React from "react";
import { Image } from "react-datocms";
import {  DiagramDato } from "./helpers";


export function Diagram({ slug, whitespace, gradient }) {
    const [diagram, setDiagram] = React.useState<DiagramDato>();

    const handleDiagram = async() => {
        const resp = require("../data/dato-diagrams.json");
        const diagram = resp.data.allDiagrams.filter(o => o.slug === slug);

        setDiagram(diagram[0]);
    };


    React.useEffect(() => {
        handleDiagram();
    }, []);

    const padding = whitespace ? "1.5rem" : 0;
    return (
        <div className="diagram-container">
            <div className={(gradient ? " gradient-bg" : "")}>
                <div className="diagram">
                    {diagram &&
                        <Image
                            data={diagram.image.responsiveImage}
                            usePlaceholder={false}
                        />
                    }

                </div>
            </div>
            {diagram &&
                <small className="caption">{diagram.caption}</small>
            }
            <style jsx>
                {`
                  .caption {
                    font-size: var(--font-size-1);
                    color: #505050;
                  }

                  .diagram {
                    border: 1px solid var(--code-border);
                    border-radius: var(--border-radius);
                    background-color: white;
                    padding: ${padding};
                  }

                  .diagram-container {
                    margin-bottom: var(--default-vertical-spacing);
                  }

                  .gradient-bg {
                    padding: 3rem;
                    background: rgb(2, 0, 36);
                    background: linear-gradient(202deg, rgba(2, 0, 36, 1) 0%, rgba(0, 216, 213, 1) 0%, rgba(255, 76, 139, 1) 100%);
                  }

                  @media screen and (max-width: 767px) {
                    .gradient-bg {
                      padding: 3px;
                      background: linear-gradient(202deg, rgba(2, 0, 36, 1) 0%, rgba(0, 216, 213, 1) 0%, rgba(255, 76, 139, 1) 100%);
                    }
                    .diagram {
                    border: 1px solid var(--code-border);
                    border-radius: var(--border-radius);
                    background-color: white;
                    padding: 6px;
                  }
                  }
                `}
            </style>
        </div>
    );
}
